module.exports = __webpack_public_path__ + "img/vermelho_vertical.4a79de32.png";